import {
  IntegrationType,
  ISendgridIntegrationData,
} from '@principle-theorem/integrations';
import { Region, type WithRef } from '@principle-theorem/shared';
import { EmailMessage } from './email-message';
import { ISORegionCode } from './sms-integration';

export const EMAIL_INTEGRATION_OPTIONS = [IntegrationType.Sendgrid];

export type EmailIntegrationOption = IntegrationType.Sendgrid;

export const EMAIL_INTEGRATION_COUNTRY_MAP: Record<
  Region,
  EmailIntegrationOption[]
> = {
  [Region.Australia]: [IntegrationType.Sendgrid],
  [Region.NewZealand]: [IntegrationType.Sendgrid],
};

export const EMAIL_INTEGRATION_REGION_CODE_MAP: Record<
  EmailIntegrationOption,
  ISORegionCode[]
> = {
  [IntegrationType.Sendgrid]: [
    ISORegionCode.Australia,
    ISORegionCode.NewZealand,
  ],
};

export interface IEmailProvider {
  sendEmail(data: WithRef<EmailMessage>): Promise<void>;
}

export type IEmailIntegrationData = ISendgridIntegrationData;
